export { ViewPaginationLabel } from './view-pagination-label';
